import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { CalendarClock, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function InstallazioneDateBlock({ cid, initialDate, readOnly = false, onSaved }) {
  const [date, setDate] = useState((initialDate || "").slice(0, 10));
  const [saving, setSaving] = useState(false);

  useEffect(() => { setDate((initialDate || "").slice(0, 10)); }, [initialDate]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/clienti/${cid}/installazione/data`, { data_installazione: date });
      toast.success("Data installazione salvata");
      onSaved?.();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="card-shell p-4 flex flex-wrap items-end gap-3" data-testid="installazione-data-block">
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider flex items-center gap-1" style={{ color: "var(--text-muted)" }}>
          <CalendarClock className="w-3.5 h-3.5" /> Data installazione effettuata
        </label>
        <input type="date" value={date} disabled={readOnly} onChange={(e) => setDate(e.target.value)}
          className="mt-1 px-3 py-2 text-sm rounded-md border outline-none disabled:opacity-60"
          style={{ borderColor: "var(--border)", background: "#fff" }}
          data-testid="installazione-data-input" />
      </div>
      {!readOnly && (
        <button onClick={save} disabled={saving} className="btn-primary text-sm" data-testid="installazione-data-save">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salva data
        </button>
      )}
      <span className="text-xs flex-1 min-w-[200px]" style={{ color: "var(--text-muted)" }}>
        Usata per contabilizzare l'installazione nel mese corretto in Analytics e Dashboard.
      </span>
    </div>
  );
}
